import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/TranslationProvider";

const PageNotFound = () => {
  const { t } = useTranslation();
  return (
    <div>
      {t("pagenotfound.message")}{" "}
      <Link to="/">{t("pagenotfound.link")}</Link>
      {" "}{t("pagenotfound.suffix")}
    </div>
  );
};

export default PageNotFound;